import React from 'react'
import ConfirmModal from './ConfirmModal'

type Props = Record<string, any>

type ModalConfig = {
  okButtonText?: string
  okButtonClass?: string
  cancelButtonText?: string
  cancelButtonClass?: string
}

type State = {
  isModalOpen: boolean
  title: string
  content?: any
  onClose: (...props: any) => any
}

const withConfirmModal = (WrappedComponent: any, modalConfig?: ModalConfig) => {
  return class extends React.Component<Props, State> {
    constructor(props: Props) {
      super(props)

      this.state = {
        isModalOpen: false,
        title: '',
        content: null,
        onClose: () => {},
      }
    }

    handleModalClose = (isConfirmed: boolean) => {
      this.state.onClose(isConfirmed)

      this.setState({
        isModalOpen: false,
        title: '',
        content: null,
        onClose: () => {},
      })
    }

    handleModalShow = (title: string, onClose: (...props: any) => any, content?: any) => {
      this.setState({
        title,
        onClose,
        content,
        isModalOpen: true,
      })
    }

    render() {
      const { isModalOpen, title } = this.state
      return (
        <React.Fragment>
          <WrappedComponent
            {...this.props}
            confirmModal={{
              show: this.handleModalShow,
            }}
          />
          <ConfirmModal title={title} open={isModalOpen} onClose={this.handleModalClose} {...modalConfig} />
        </React.Fragment>
      )
    }
  }
}

export default withConfirmModal
